/** */
const autoCompleter = (editor, placeholders) => {
  const onAction = (autocompleteApi, rng, value) => {
    editor.selection.setRng(rng);
    editor.insertContent(value);
    autocompleteApi.hide();
  };

  editor.ui.registry.addAutocompleter('templatestringcharacter', {
    ch: '@',
    fetch: (pattern) => {
      return new Promise(function (resolve) {
        const q = pattern.substr(1).toLowerCase();
        const matches = (p) =>
          !q || p.value.toLowerCase().includes(q) || p.text.toLowerCase().includes(q);

        const defaults = placeholders.filter((p) => p.type !== 'custom' && matches(p));
        const customs = placeholders.filter((p) => p.type === 'custom' && matches(p));

        const results = defaults.slice(0, 10).map((r) => ({ ...r, type: 'autocompleteitem' }));

        if (customs.length) {
          results.push({ type: 'separator' });
          customs
            .slice(0, 10 - defaults.length)
            .forEach((r) => results.push({ ...r, type: 'autocompleteitem' }));
        }

        resolve(results);
      });
    },
    minChars: 0,
    onAction
  });
};

export const tiny_config = (
  file_picker_callback = () => {},
  images_upload_handler = () => {},
  placeholder = '',
  auto_complete_options = []
) => ({
  autoresize_bottom_margin: 25,
  autoresize_overflow_padding: 25,
  branding: false,
  browser_spellcheck: true,
  default_link_target: '_blank',
  entity_encoding: 'raw',
  extended_valid_elements: '*[*]',
  file_picker_callback: () => file_picker_callback,
  file_picker_types: 'file',
  fullpage_default_doctype: '<!DOCTYPE html>',
  fullpage_default_encoding: 'UTF-8',
  height: '100%',
  images_reuse_filename: true,
  images_upload_handler,
  image_uploadtab: true,
  menubar: false,
  placeholder,
  valid_elements: '*[*]',
  plugins:
    'autolink autosave code fullpage fullscreen hr image link lists preview spellchecker wordcount quickbars',
  setup: (editor) => {
    autoCompleter(editor, auto_complete_options);
    if (auto_complete_options.length > 0) {
      editor.ui.registry.addMenuButton('personalize', {
        text: 'Personalize',
        tooltip: 'Insert placeholder',
        fetch: (callback) => {
          const defaults = auto_complete_options.filter((p) => p.type !== 'custom');
          const customs = auto_complete_options.filter((p) => p.type === 'custom');

          const toItem = (p) => ({
            type: 'menuitem',
            text: p.text,
            onAction: () => editor.insertContent(p.value)
          });

          const items = defaults.map(toItem);

          if (customs.length) {
            items.push({ type: 'separator' });
            customs.forEach((p) => items.push(toItem(p)));
          }

          callback(items);
        }
      });
    }
  },
  toolbar: `preview code fullscreen | ${
    auto_complete_options.length > 0 ? 'personalize |' : ''
  } formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | numlist bullist blockquote |
        quickimage link hr restoredraft spellchecker wordcount`,
  toolbar_mode: 'floating',
  toolbar_sticky: false
});

/** Inline mode — no persistent toolbar, design-system editor */
export const tiny_inline_config = (
  file_picker_callback = () => {},
  images_upload_handler = () => {},
  placeholder = '',
  auto_complete_options = []
) => ({
  browser_spellcheck: true,
  default_link_target: '_blank',
  entity_encoding: 'raw',
  extended_valid_elements: '*[*]',
  file_picker_callback: () => file_picker_callback,
  file_picker_types: 'file',
  fullpage_default_doctype: '<!DOCTYPE html>',
  fullpage_default_encoding: 'UTF-8',
  images_reuse_filename: true,
  images_upload_handler,
  image_uploadtab: true,
  menubar: false,
  toolbar: false,
  quickbars_selection_toolbar: false,
  quickbars_insert_toolbar: false,
  image_toolbar: false,
  object_resizing: 'img',
  quickbars_image_toolbar: false,
  placeholder,
  valid_elements: '*[*]',
  plugins: 'autolink autosave fullpage hr image link lists wordcount quickbars',
  setup: (editor) => {
    autoCompleter(editor, auto_complete_options);

    /* Exit blockquote on Enter when caret is at the very end */
    editor.on('keydown', (e) => {
      if (e.key !== 'Enter' || e.shiftKey) return;
      const node = editor.selection.getNode();
      const blockquote = editor.dom.getParent(node, 'blockquote');
      if (!blockquote) return;

      const rng = editor.selection.getRng();
      const atEnd =
        rng.collapsed &&
        rng.endOffset === (rng.endContainer.length || 0) &&
        !rng.endContainer.nextSibling;

      if (atEnd) {
        e.preventDefault();
        // Insert a paragraph after the blockquote
        editor.dom.insertAfter(editor.dom.create('p', {}, '\u00a0'), blockquote);
        // Move caret into the new paragraph
        const next = blockquote.nextSibling;
        if (next) {
          const newRng = editor.dom.createRng();
          newRng.setStart(next, 0);
          newRng.setEnd(next, 0);
          editor.selection.setRng(newRng);
          editor.focus();
        }
      }
    });
  }
});
